import { api } from './client'
import type { components } from './generated/schema'

// Types come from the generated OpenAPI schema (pnpm api:types) so a BE
// contract change surfaces here at compile time instead of at runtime.
export type Province = components['schemas']['Province']
export type Ward = components['schemas']['Ward']

export async function fetchProvinces(): Promise<Array<Province>> {
    const res = await api.get<Array<Province>>('/admin-units/provinces')
    return res.data ?? []
}

export async function fetchWardsByProvince(
    provinceCode: string,
): Promise<Array<Ward>> {
    const res = await api.get<Array<Ward>>(
        `/admin-units/provinces/${provinceCode}/wards`,
    )
    return res.data ?? []
}
